import { AppComponent } from "~core/AppComponent.js";
import { createExampleOptions } from "./example.templates.js";
//import Tooltip from "~core/tooltip";
import Tooltip from "@kamenskii/tooltip";

export class Example extends AppComponent {
  constructor($root, options) {
    super($root, {
      name: "Example",
      listeners: ["mouseenter"],
      ...options,
    });

    this.setting = {
      cross: false,
      tooltipMove: false,
      arrow: false,
      arrowPosition: 'center',
      position: "left",
      class: "tooltip-class",
      margin: 15
    };

    this.tooltip = new Tooltip(this.$root.$el, this.setting);

    this.emitter.subscribe("form:change", (settings, name, value) => {
      this.setting = { ...this.setting, ...settings };
      const changeVal = this.$root
        .find(`[id=${name}]`)
        .html(`${name}: <span>${value}</span>`);
      _animationText(changeVal.$el);
      this.tooltip.destroy();
      this.tooltip = new Tooltip(this.$root.$el, this.setting);
    });
  }
  static className = ["app__example", "article"];

  toHTML() {
    return createExampleOptions(this.setting);
  }
  onMouseenter() {
    this.tooltip.open("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ");
  }
}

function _animationText($el) {
  $el = $el.lastChild;

  const opacityAnimate = (ms = 40) => {
    let animationStart = false;
    if (animationStart) return;
    animationStart = true;
    let opacity = 0.1;
    let timerId = setInterval(() => {
      $el.style.background = `rgba(249, 191, 59, ${opacity})`;
      if (opacity >= 0.7) {
        clearInterval(timerId);
        let timerId2 = setInterval(() => {
          $el.style.background = `rgba(249, 191, 59, ${opacity})`;
          if (opacity === 0) {
            clearInterval(timerId2);
          } else {
            opacity = opacity - 0.1;
          }
        }, ms);
      } else {
        opacity = opacity + 0.1;
      }
    }, ms);
  };

  opacityAnimate();
}
